import { resolvePrinterReparto, isBlockedReparto } from './repartoMap'

export const VOID_COMMAND = '25F'
export const CLEAR_COMMAND = 'K'

const sanitizeDesc = (desc) => String(desc || 'Articolo')
  .replace(/[^a-zA-Z0-9. _-]/g, '')
  .substr(0, 30)

const buildLineCommand = ({ desc, qty, unitPriceCents, appReparto, pesoSfuso }) => {
  const dept = resolvePrinterReparto({ appReparto, pesoSfuso })
  if (!dept) {
    throw new Error(`Reparto app ${appReparto} non utilizzabile in stampa`)
  }
  const description = sanitizeDesc(desc)
  const price = Math.max(0, Math.floor(unitPriceCents))
  const quantity = Math.max(1, Math.floor(qty || 1))
  const core = `"${description}"${price}H${dept}R`
  return { command: quantity > 1 ? `${quantity}*${core}` : core, dept, lineTotalCents: price * quantity }
}

/** Sconto importo sulla riga precedente (protocollo 3i: es. 250H3R50H3M → sconto 50H3M) */
const buildDiscountCommand = (discountCents, dept, maxCents) => {
  const amount = Math.max(0, Math.floor(discountCents))
  if (!dept || amount <= 0) {
    throw new Error('Sconto non valido')
  }
  if (maxCents != null && amount > maxCents) {
    throw new Error(`Sconto superiore alla riga precedente (${amount} > ${maxCents} centesimi)`)
  }
  // Il "3" è il tipo modificatore (sconto ammontare riga precedente), non il reparto cassa.
  return `${amount}H3M`
}

const buildLotteryCommand = (lottery) => {
  const code = String(lottery || '').replace(/\D/g, '').substr(0, 24)
  if (code.length < 5) return null
  return `${code}#`
}

const buildPaymentCommand = (payment, totalCents) => {
  const total = Math.max(0, Math.floor(totalCents))
  if (payment === 'contanti') {
    return `${total}H1T`
  }
  return '3T'
}

export const buildVoidCommand = () => VOID_COMMAND

export const buildReceiptCommands = (receipt) => {
  const errors = []
  const commands = []
  let lastSaleDept = null
  let lastSaleLineCents = null
  let computedSubtotalCents = 0

  for (const line of receipt.lines || []) {
    if (line.isDiscount) {
      try {
        if (!lastSaleDept) {
          throw new Error('Sconto senza riga vendita precedente')
        }
        const discountCents = Math.abs(Math.floor(line.discountCents || line.unitPriceCents || 0))
        commands.push(buildDiscountCommand(discountCents, lastSaleDept, lastSaleLineCents))
        computedSubtotalCents -= discountCents
        lastSaleLineCents = Math.max(0, lastSaleLineCents - discountCents)
      } catch (e) {
        errors.push(e.message)
      }
      continue
    }

    if (isBlockedReparto(line.appReparto)) {
      errors.push(`Reparto "Non Usare" su riga: ${line.desc || '?'}`)
      continue
    }
    try {
      const built = buildLineCommand(line)
      commands.push(built.command)
      computedSubtotalCents += built.lineTotalCents
      lastSaleDept = built.dept
      lastSaleLineCents = built.lineTotalCents
    } catch (e) {
      errors.push(e.message)
    }
  }

  if (errors.length) {
    return { OK: false, Errors: errors, commands: [] }
  }

  const saleTotalCents = Math.max(0, Math.floor(receipt.totalCents || 0))
  if (Math.abs(computedSubtotalCents - saleTotalCents) > 1) {
    return {
      OK: false,
      Errors: [`Totale vendita (${saleTotalCents}) non coincide con righe scontrino (${computedSubtotalCents})`],
      commands: [],
      computedSubtotalCents
    }
  }

  const lotteryCmd = buildLotteryCommand(receipt.lottery)
  if (lotteryCmd) commands.push(lotteryCmd)

  let paymentCents = computedSubtotalCents
  const tenderedCents = Math.floor(receipt.tenderedCents || 0)
  if (receipt.payment === 'contanti' && tenderedCents >= computedSubtotalCents) {
    paymentCents = tenderedCents
  }

  const paymentCommand = buildPaymentCommand(receipt.payment, paymentCents)
  commands.push(paymentCommand)

  return {
    OK: true,
    commands,
    Errors: [],
    computedSubtotalCents,
    paymentCommand,
    paymentCents
  }
}

export const buildStatusCommand = () => '89F'
